<script>
  import { onMount, tick } from "svelte"
  import { navigate } from "svelte-routing"
  import Container from "../Container.svelte"
  import ScoreCircular from "./ScoreCircular.svelte"
  import { user } from "../../stores/User"
  import Modal from "../Modal.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import Spinner from "../Spinner.svelte"
  import SinInformacion from "../Sin_informacion.svelte"
  import { Popover } from "../../services/bootstrap.js"

  export let documento = ""
  export let nombres = ""
  export let score = 0
  export let categoria = ""

  let data = {
    persona: undefined,
    loading: false,
  }

  let isLoading = true
  let isOpenFoto = false
  let loadingFoto = false
  let foto = null
  let errorFoto = ""

  const handleFoto = async () => {
    if (!$user?.permisos?.includes("foto") || loadingFoto) return

    isOpenFoto = true
    loadingFoto = true
    foto = null
    errorFoto = ""

    try {
      const params = new URLSearchParams({
        documento,
        session_key: $user.session_key,
        ops: "general_fotos",
      })
      const response = await fetch(`${BASE_URL}persona.php?${params}`)
      if (!response.ok) throw new Error("No se pudo cargar la firma y foto.")
      const resp = await response.json()
      if (resp.status === "error" || resp.data?.error_id !== undefined) {
        throw new Error(
          resp.data?.message || "No se pudo cargar la firma y foto.",
        )
      }
      foto = resp.data
    } catch (error) {
      console.error("Error al obtener firma y foto:", error)
      errorFoto = error.message || "No se pudo cargar la firma y foto."
    } finally {
      loadingFoto = false
    }
  }

  let botonRangos

  const coloresCategoria = {
    "Excelente Puntaje": "#15803D",
    "Buen Puntaje": "#8AA03B",
    "Puntaje Medio": "#ffbf39",
    "Puntaje Bajo": "#ff7800",
    "Puntaje Muy Bajo": "#EF4444",
  }

  const rangos = [
    { nombre: "Excelente Puntaje", rango: "880–999", color: "#16a34a" },
    { nombre: "Buen Puntaje", rango: "720–879", color: "#8ab142" },
    { nombre: "Puntaje Medio", rango: "600–719", color: "#ffbf39" },
    { nombre: "Puntaje Bajo", rango: "480–599", color: "#ff7800" },
    { nombre: "Puntaje Muy Bajo", rango: "1–479", color: "#EF4444" },
  ]

  $: colorCategoria = coloresCategoria[categoria?.trim()] || "#6c757d"
  $: rangoCategoria = rangos.find((rango) => rango.nombre === categoria?.trim())?.rango ?? "—"

  const contenidoRangos = () =>
    `<ul class="pop-rangos list-unstyled mb-0">
      ${rangos
        .map(
          (rango) => `
            <li>
              <span
                class="pop-color"
                aria-hidden="true"
                style="background-color:${rango.color}"
              ></span>

              <span class="flex-grow-1">
                ${rango.nombre}
              </span>

              <span class="pop-valor">
                ${rango.rango}
              </span>
            </li>
          `,
        )
        .join("")}
    </ul>`

  onMount(() => {
    let popover
    let desmontado = false

    const cerrarLeyendaFuera = (event) => {
      const leyendaId = botonRangos?.getAttribute("aria-describedby")
      const leyenda = leyendaId ? document.getElementById(leyendaId) : null
      if (botonRangos?.contains(event.target) || leyenda?.contains(event.target)) return
      popover?.hide()
    }

    document.addEventListener("pointerdown", cerrarLeyendaFuera, true)

    const cargar = async () => {
      await cargarDatos()
      await tick()
      if (desmontado || !botonRangos) return

      popover = new Popover(botonRangos, {
        html: true,
        sanitize: false,
        trigger: "click",
        placement: "bottom",
        container: "body",
      })
    }

    cargar()

    return () => {
      desmontado = true
      document.removeEventListener("pointerdown", cerrarLeyendaFuera, true)
      popover?.dispose()
    }
  })

  // CRM
  let session_key = $user.session_key
  let personaLoaded = false
  let isOpen = false

  let crm = {
    segmentos: [],
    productos: [],
    productos_por_segmento: [],
  }

  let isAdding = false

  let cliente = {
    tipo_doc: "DNI",
    documento: "",
    nombres: "",
    descripcion: "",
    id_segmento: "0",
    id_producto: "1",
    session_key: session_key,
  }

  $: if (documento.trim() && nombres.trim() && !personaLoaded) {
    cliente.documento = documento
    cliente.nombres = nombres
    cliente.tipo_doc = documento.length === 8 ? "DNI" : "CARNET EXT."
    personaLoaded = true
  }

  const getSegmentos = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}crm.php?ops=getSegmentos&session_key=${session_key}`,
      )

      const data = await response.json()

      if (data.status === "ok") {
        crm.segmentos = data.data.filter((seg) => seg.estado === "1")
      } else {
        crm.segmentos = []
      }
    } catch (error) {
      console.error("Error al obtener segmentos:", error)
      crm.segmentos = []
    }
  }

  const getProductos = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}crm.php?ops=getProductos&session_key=${session_key}`,
      )

      const data = await response.json()

      if (data.status === "ok") {
        crm.productos = data.data
      } else {
        crm.productos = []
      }
    } catch (error) {
      console.error("Error al obtener productos:", error)
      crm.productos = []
    }
  }

  const addCliente = async () => {
    if (
      cliente.nombres.trim() === "" ||
      cliente.documento.trim() === "" ||
      cliente.id_segmento === "0"
    ) {
      alert("Por favor, complete todos los campos.")
      return
    }

    isAdding = true

    try {
      const response = await fetch(`${BASE_URL}crm.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ops: "addCliente",
          ...cliente,
        }),
      })

      const data = await response.json()

      if (data.status === "ok") {
        isOpen = false
        alert("Cliente agregado correctamente.")
      } else {
        alert("Error al agregar cliente: " + data.message)
      }
    } catch (error) {
      console.error("Error al agregar cliente:", error)
      alert("Ocurrió un error al agregar el cliente.")
    } finally {
      isAdding = false
    }
  }

  const buscarPersona = async () => {
    const ops = "general_datos"
    let url = `${BASE_URL}persona.php?documento=${documento}&session_key=${session_key}&ops=${ops}`
    data.loading = true
    const response = await fetch(url)
    const resp = await response.json()

    if (resp.data.error_id !== undefined) {
      alert(resp.data.message)
      navigate("/", { replace: true })
      return
    }

    data = {
      persona: resp.data,
      loading: false,
    }

    data.persona.edad = calcularEdad(data.persona.nacimiento)
  }

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date()
    const [anio, mes, dia] = fechaNacimiento.split("-").map(Number)

    const nacimiento = new Date(anio, mes - 1, dia)

    if (isNaN(nacimiento.getTime())) {
      return ""
    }

    let edad = hoy.getFullYear() - nacimiento.getFullYear()

    const mesNacimiento = nacimiento.getMonth()
    const diaNacimiento = nacimiento.getDate()
    const mesActual = hoy.getMonth()
    const diaActual = hoy.getDate()

    if (
      mesActual < mesNacimiento ||
      (mesActual === mesNacimiento && diaActual < diaNacimiento)
    ) {
      edad--
    } else {
      console.log("Día actual: " + diaActual)
      console.log("Día nacimiento: " + diaNacimiento)
    }

    if (edad < 0 || edad > 130) {
      return ""
    }

    return edad
  }

  const cargarDatos = async () => {
    isLoading = true
    const resultados = await Promise.allSettled([
      buscarPersona(),
      getSegmentos(),
      getProductos(),
    ])
    for (const resultado of resultados) {
      if (resultado.status === "rejected") {
        console.error("Error al cargar la cabecera:", resultado.reason)
      }
    }
    isLoading = false
  }

  $: if (cliente.id_segmento !== "1") {
    crm.productos_por_segmento = crm.productos.filter(
      (prod) => prod.id_segmento === cliente.id_segmento && prod.estado === "1",
    )
  } else {
    crm.productos_por_segmento = []
    cliente.id_producto = "1"
  }
</script>

<Container>
  {#if isLoading}
    <Spinner />
  {:else}
    <div class="row g-5 align-items-center">
      <div
        class="col-12 sm:col-12 md:col-12 lg:col-6 xl:col-5 text-center lg:text-start"
      >
        <h6 class="mb-0 fs-md mb-1">
          {nombres}
        </h6>

        <p
          class="small fg-3 d-flex flex-wrap align-items-center justify-content-center lg:justify-content-start gap-1"
        >
          <span class="me-3">Documento: {cliente.documento}</span>
          <span class="badge theme-secondary"
            >{data.persona?.edad ?? ""} años</span
          >
          <span class="badge theme-success"
            >{data.persona?.nivel_educacion ?? ""}</span
          >
        </p>
      </div>

      <div
        class="col-12 sm:col-12 md:col-12 lg:col-6 xl:col-5 d-flex justify-content-center xl:justify-content-start align-items-center gap-5"
      >
        <ScoreCircular {score} />
        <div>
          <p style:color={colorCategoria} class="mb-0 fw-semibold small">
            {categoria}
          </p>

          <p class="mb-0 small">
            Rango: {rangoCategoria}
          </p>

          <p class="fg-secondary mb-3 small">Escala: 1 - 999</p>

          <button
            bind:this={botonRangos}
            type="button"
            class="btn btn-outline theme-secondary btn-sm"
            data-bs-toggle="popover"
            data-bs-title="Rangos del score"
            data-bs-content={contenidoRangos()}
          >
            <small class="px-0 mx-0">
              <i class="bi bi-info-circle me-1"></i>
              Ver rangos del score
            </small>
          </button>
        </div>
      </div>

      <div class="col-12 lg:col-12 xl:col-2 d-grid gap-2">
        <button
          type="button"
          class="btn btn-solid theme-primary btn-sm xl:w-100"
          disabled={!personaLoaded}
          on:click={() => (isOpen = true)}
        >
          <small class="px-0 mx-0"
            ><i class="bi bi-person-plus-fill me-1"></i> Agregar a CRM
          </small>
        </button>
        {#if $user.permisos.includes("foto")}
          <button
            type="button"
            class="btn btn-solid theme-neutral btn-sm xl:w-100"
            disabled={loadingFoto}
            on:click={handleFoto}
          >
            <small class="px-0 mx-0">
              <i class="bi bi-person-bounding-box me-1"></i>
              Ver Firma y Foto
            </small>
          </button>
        {/if}
      </div>
    </div>
  {/if}

  <Modal
    isOpen={isOpenFoto && $user.permisos.includes("foto")}
    on:close={() => (isOpenFoto = false)}
    title="Firma y Foto"
  >
    {#if loadingFoto}
      <Spinner />
    {:else if errorFoto}
      <div class="alert theme-danger" role="alert">{errorFoto}</div>
      <button
        type="button"
        class="btn btn-solid theme-primary btn-sm"
        on:click={handleFoto}
      >
        Reintentar
      </button>
    {:else if !foto || (!foto.firma && !foto.indicederecho && !foto.foto)}
      <SinInformacion />
    {:else}
      <div class="row g-5 align-items-end justify-content-center">
        {#if foto.firma}
          <div class="col-12 sm:col-5 text-center">
            <img
              class="img-fluid"
              src="data:image/jpeg;base64,{foto.firma}"
              alt="Firma"
            />
            <p class="fg-secondary mb-0">Firma</p>
          </div>
        {/if}
        {#if foto.indicederecho}
          <div class="col-12 sm:col-3 text-center">
            <img
              width="125"
              class="img-fluid"
              src="data:image/jpeg;base64,{foto.indicederecho}"
              alt="Índice derecho"
            />
            <p class="fg-secondary mb-0">Índice derecho</p>
          </div>
        {/if}
        {#if foto.foto}
          <div class="col-12 sm:col-4 text-center">
            <img
              class="img-fluid"
              src="data:image/jpeg;base64,{foto.foto}"
              alt="Foto"
            />
          </div>
        {/if}
      </div>
    {/if}
  </Modal>

  <Modal
    {isOpen}
    on:close={() => (isOpen = false)}
    title="Agregar cliente a CRM"
  >
    <div class="mb-3">
      <label for="segmento" class="form-label fg-secondary"> Segmento </label>

      <select
        id="segmento"
        class="form-control form-control-sm"
        bind:value={cliente.id_segmento}
      >
        <option value="0"> Seleccione un segmento </option>

        {#each crm.segmentos as segmento}
          <option value={segmento.id}>
            {segmento.nombre}
          </option>
        {/each}
      </select>
    </div>

    <div class="mb-3">
      <label for="producto" class="form-label fg-secondary"> Producto </label>

      <select
        id="producto"
        class="form-control form-control-sm"
        bind:value={cliente.id_producto}
      >
        <option value="1"> SIN PRODUCTO </option>

        {#each crm.productos_por_segmento as producto}
          <option value={producto.id}>
            {producto.nombre}
          </option>
        {/each}
      </select>
    </div>

    <svelte:fragment slot="footer">
      {#if isAdding}
        <button class="btn btn-solid theme-primary btn-sm disabled" disabled>
          <i class="bi bi-person-plus-fill"></i> Agregando...
        </button>
      {:else}
        <button
          class="btn btn-solid theme-primary btn-sm"
          on:click={addCliente}
        >
          <i class="bi bi-person-plus-fill"></i> Agregar
        </button>
      {/if}
    </svelte:fragment>
  </Modal>
</Container>

<style>
  :global(.popover) {
    max-width: 360px;
    border-radius: 10px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  }

  :global(.popover-header) {
    font-size: 14px;
    font-weight: 600;
  }

  :global(.popover-body) {
    padding: 12px 14px;
  }

  :global(.pop-rangos) {
    min-width: 280px;
  }

  :global(.pop-rangos li) {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 0;
    font-size: 13px;
  }

  :global(.pop-rangos li:not(:last-child)) {
    border-bottom: 1px solid #f0f0f0;
  }

  :global(.pop-color) {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  :global(.pop-valor) {
    font-weight: 600;
    color: #495057;
    white-space: nowrap;
  }
</style>
